import Container from "../Helper/Container";
import React, { useState } from "react";
import CrossButton from "../Buttons/CrossButton";

const classes = {
  bg: {
    default: "absolute top-0 left-0 z-50 h-full w-full bg-theme-secondary bg-opacity-70",
    lg: "sm:flex sm:justify-center sm:align-middle",
  },
  modal: {
    default: "absolute bottom-0 bg-theme-primary rounded-tl-default rounded-tr-default w-full h-auto",
    lg: "sm:static sm:max-w-lg sm:m-auto sm:p-2 sm:rounded-default",
  },
};

const BaseModal = ({ className, children, handleCloseModal }) => {
  const [showModal, setShowModal] = useState(true);

  const handleHideModal = (event) => {
    if (handleCloseModal) {
      return handleCloseModal(event);
    }

    setShowModal(false);
  };

  if (!showModal || !children) {
    return null;
  }

  return (
    <div
      className={`${classes.bg.default} ${classes.bg.lg} ${className}`}
      onClick={handleHideModal}
      style={{ backgroundColor: "rgba(36,38,39,0.7)" }}
    >
      <div className={`${classes.modal.default} ${classes.modal.lg}`} onClick={(e) => e.stopPropagation()}>
        <Container className="relative">
          <CrossButton onCancel={handleHideModal} />
          {children}
        </Container>
      </div>
    </div>
  );
};

export default BaseModal;
